import { GETTERS } from './constants'

export const getters = {
  [GETTERS.GET_GROUPS]: (state) => {
    return state.groups.map(g => ({
      ...g,
      filters: g.filters.map(key => state.filters.find(f => f.key === key)).filter(Boolean)
    }))
  },
  [GETTERS.GET_FILTERS]: (state) => {
    return state.filters.filter(f => !f.external)
  },
  [GETTERS.GET_ROUTE_FILTERS]: (state) => {
    const groupKeys = state.activeGroups || []
    const groups = state.groups.filter(g => groupKeys.indexOf(g.value) !== -1)
    const filterKeys = groups.map(g => g.filters).flat()

    return state.filters ? state.filters.filter(f => f.external || filterKeys.indexOf(f.key) !== -1) : []
  },
  [GETTERS.GET_POIS_FILTERS]: (state) => {
    return state.localPoisTextSearch
  },
  [GETTERS.GET_ADVERTS_FILTERS]: (state) => {
    return state.localAdvertsTextSearch
  },
  [GETTERS.GET_SHOPS_FILTERS]: (state) => {
    return state.localShopsTextSearch
  }
}
